import React from 'react';
import ArticleWrapper from '../../components/ArticleWrapper';

const CherryMX2ABlack = () => (
  <ArticleWrapper articleId="cherry_mx2a_black">
    <div className="prose prose-invert mx-auto p-6">
      <h1>Cherry MX2A Black</h1>
      {/* Add your Cherry MX2A Black article content here */}
      <p>This is a placeholder article for the Cherry MX2A Black switch. More content coming soon.</p>
    </div>
  </ArticleWrapper>
);

export default CherryMX2ABlack;
